/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Verdi Dashboard API
 * API for the Verdi Dashboard application
 * OpenAPI spec version: 1.0.0
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult,
} from "@tanstack/react-query";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { customFetch } from "../custom-fetch.ts";
import type {
	CreateOrganization400,
	CreateOrganization403,
	CreateOrganization500,
	DeleteOrganization400,
	DeleteOrganization403,
	DeleteOrganization404,
	DeleteOrganization500,
	GetMyOrganization400,
	GetMyOrganization500,
	GetMyOrganizationSettings200,
	GetMyOrganizationSettings400,
	GetMyOrganizationSettings500,
	GetOrganization400,
	GetOrganization403,
	GetOrganization404,
	GetOrganization500,
	ListOrganizations400,
	ListOrganizations403,
	ListOrganizations500,
	ListOrganizationsParams,
	Organization,
	OrganizationCreate,
	OrganizationUpdate,
	UpdateMyOrganizationPollTimes200,
	UpdateMyOrganizationPollTimes400,
	UpdateMyOrganizationPollTimes500,
	UpdateMyOrganizationPollTimesBody,
	UpdateMyOrganizationSettings200,
	UpdateMyOrganizationSettings400,
	UpdateMyOrganizationSettings500,
	UpdateMyOrganizationSettingsBody,
	UpdateOrganization400,
	UpdateOrganization403,
	UpdateOrganization404,
	UpdateOrganization500,
} from "./schemas";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
	query: T,
	queryKey: K,
): T & { queryKey: K } => {
	const result = { queryKey } as T & { queryKey: K };
	for (const key of Object.keys(query)) {
		// The explicit queryKey always wins, matching the previous
		// `{ ...query, queryKey }` spread where it was set last.
		if (key === "queryKey") continue;
		Object.defineProperty(result, key, {
			enumerable: true,
			configurable: true,
			get: () => (query as Record<string, unknown>)[key],
		});
	}
	return result;
};

export const getListOrganizationsUrl = (params?: ListOrganizationsParams) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : String(value));
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0
		? `/organizations?${stringifiedParams}`
		: `/organizations`;
};

/**
 * @summary List organizations with optional filters (admin only)
 */
export const listOrganizations = async (
	params?: ListOrganizationsParams,
	options?: Parameters<typeof customFetch>[1],
): Promise<Organization[]> => {
	return customFetch<Organization[]>(getListOrganizationsUrl(params), {
		...options,
		method: "GET",
	});
};

export const getListOrganizationsQueryKey = (
	params?: ListOrganizationsParams,
) => {
	return ["organizations", ...(params ? [params] : [])] as const;
};

export const getListOrganizationsQueryOptions = <
	TData = Awaited<ReturnType<typeof listOrganizations>>,
	TError = ListOrganizations400 | ListOrganizations403 | ListOrganizations500,
>(
	params?: ListOrganizationsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listOrganizations>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getListOrganizationsQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listOrganizations>>
	> = ({ signal }) => listOrganizations(params, { signal, ...requestOptions });

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listOrganizations>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOrganizationsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listOrganizations>>
>;
export type ListOrganizationsQueryError =
	| ListOrganizations400
	| ListOrganizations403
	| ListOrganizations500;

export function useListOrganizations<
	TData = Awaited<ReturnType<typeof listOrganizations>>,
	TError = ListOrganizations400 | ListOrganizations403 | ListOrganizations500,
>(
	params: undefined | ListOrganizationsParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listOrganizations>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listOrganizations>>,
					TError,
					Awaited<ReturnType<typeof listOrganizations>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOrganizations<
	TData = Awaited<ReturnType<typeof listOrganizations>>,
	TError = ListOrganizations400 | ListOrganizations403 | ListOrganizations500,
>(
	params?: ListOrganizationsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listOrganizations>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listOrganizations>>,
					TError,
					Awaited<ReturnType<typeof listOrganizations>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOrganizations<
	TData = Awaited<ReturnType<typeof listOrganizations>>,
	TError = ListOrganizations400 | ListOrganizations403 | ListOrganizations500,
>(
	params?: ListOrganizationsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listOrganizations>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List organizations with optional filters (admin only)
 */

export function useListOrganizations<
	TData = Awaited<ReturnType<typeof listOrganizations>>,
	TError = ListOrganizations400 | ListOrganizations403 | ListOrganizations500,
>(
	params?: ListOrganizationsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listOrganizations>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getListOrganizationsQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List organizations with optional filters (admin only)
 */
export const useSetListOrganizationsQueryData = () => {
	const queryClient = useQueryClient();
	return (
		params: ListOrganizationsParams | undefined,
		updater:
			| Awaited<ReturnType<typeof listOrganizations>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof listOrganizations>> | undefined,
			  ) => Awaited<ReturnType<typeof listOrganizations>> | undefined),
		$exactMatch: boolean = true,
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof listOrganizations>>>(
			{ exact: $exactMatch, queryKey: getListOrganizationsQueryKey(params) },
			updater,
		);
	};
};

/**
 * @summary List organizations with optional filters (admin only)
 */
export const useGetListOrganizationsQueryData = () => {
	const queryClient = useQueryClient();
	return (params?: ListOrganizationsParams) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof listOrganizations>>>(
			getListOrganizationsQueryKey(params),
		);
};

export const getCreateOrganizationUrl = () => {
	return `/organizations`;
};

/**
 * @summary Create a new organization (admin only)
 */
export const createOrganization = async (
	organizationCreate: OrganizationCreate,
	options?: Parameters<typeof customFetch>[1],
): Promise<Organization> => {
	const getHeaders = (
		h?: NonNullable<RequestInit["headers"]>,
	): Record<string, string | readonly string[]> => {
		if (!h) return {};
		if (h instanceof Headers) return Object.fromEntries(h.entries());
		if (Symbol.iterator in h) {
			return Object.fromEntries(
				Array.from(
					h as Iterable<Iterable<string>>,
					(entry) => Array.from(entry) as [string, string],
				),
			);
		}
		const headers: Record<string, string | readonly string[]> = {};
		for (const [name, value] of Object.entries<
			string | readonly string[] | undefined
		>(h)) {
			if (value !== undefined) headers[name] = value;
		}
		return headers;
	};
	return customFetch<Organization>(getCreateOrganizationUrl(), {
		...options,
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			...getHeaders(options?.headers),
		},
		body: JSON.stringify(organizationCreate),
	});
};

export const getCreateOrganizationMutationKey = () =>
	["createOrganization"] as const;

export const getCreateOrganizationMutationOptions = <
	TError =
		| CreateOrganization400
		| CreateOrganization403
		| CreateOrganization500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createOrganization>>,
		TError,
		CreateOrganizationMutationVariables,
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createOrganization>>,
	TError,
	CreateOrganizationMutationVariables,
	TContext
> => {
	const mutationKey = getCreateOrganizationMutationKey();
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createOrganization>>,
		CreateOrganizationMutationVariables
	> = (props) => {
		const { data } = props ?? {};

		return createOrganization(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateOrganizationMutationResult = NonNullable<
	Awaited<ReturnType<typeof createOrganization>>
>;
export type CreateOrganizationMutationBody = OrganizationCreate;
export type CreateOrganizationMutationError =
	| CreateOrganization400
	| CreateOrganization403
	| CreateOrganization500;
export type CreateOrganizationMutationVariables = { data: OrganizationCreate };

/**
 * @summary Create a new organization (admin only)
 */
export const useCreateOrganization = <
	TError =
		| CreateOrganization400
		| CreateOrganization403
		| CreateOrganization500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof createOrganization>>,
			TError,
			CreateOrganizationMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof createOrganization>>,
	TError,
	CreateOrganizationMutationVariables,
	TContext
> => {
	return useMutation(
		getCreateOrganizationMutationOptions(options),
		queryClient,
	);
};
export const getGetMyOrganizationUrl = () => {
	return `/organizations/me`;
};

/**
 * @summary Get the authenticated user's own organization record
 */
export const getMyOrganization = async (
	options?: Parameters<typeof customFetch>[1],
): Promise<Organization> => {
	return customFetch<Organization>(getGetMyOrganizationUrl(), {
		...options,
		method: "GET",
	});
};

export const getGetMyOrganizationQueryKey = () => {
	return ["organizations", "me"] as const;
};

export const getGetMyOrganizationQueryOptions = <
	TData = Awaited<ReturnType<typeof getMyOrganization>>,
	TError = GetMyOrganization400 | GetMyOrganization500,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getMyOrganization>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customFetch>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetMyOrganizationQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getMyOrganization>>
	> = ({ signal }) => getMyOrganization({ signal, ...requestOptions });

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getMyOrganization>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyOrganizationQueryResult = NonNullable<
	Awaited<ReturnType<typeof getMyOrganization>>
>;
export type GetMyOrganizationQueryError =
	| GetMyOrganization400
	| GetMyOrganization500;

export function useGetMyOrganization<
	TData = Awaited<ReturnType<typeof getMyOrganization>>,
	TError = GetMyOrganization400 | GetMyOrganization500,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getMyOrganization>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getMyOrganization>>,
					TError,
					Awaited<ReturnType<typeof getMyOrganization>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyOrganization<
	TData = Awaited<ReturnType<typeof getMyOrganization>>,
	TError = GetMyOrganization400 | GetMyOrganization500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getMyOrganization>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getMyOrganization>>,
					TError,
					Awaited<ReturnType<typeof getMyOrganization>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyOrganization<
	TData = Awaited<ReturnType<typeof getMyOrganization>>,
	TError = GetMyOrganization400 | GetMyOrganization500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getMyOrganization>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get the authenticated user's own organization record
 */

export function useGetMyOrganization<
	TData = Awaited<ReturnType<typeof getMyOrganization>>,
	TError = GetMyOrganization400 | GetMyOrganization500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getMyOrganization>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetMyOrganizationQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get the authenticated user's own organization record
 */
export const useSetGetMyOrganizationQueryData = () => {
	const queryClient = useQueryClient();
	return (
		updater:
			| Awaited<ReturnType<typeof getMyOrganization>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof getMyOrganization>> | undefined,
			  ) => Awaited<ReturnType<typeof getMyOrganization>> | undefined),
		$exactMatch: boolean = true,
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof getMyOrganization>>>(
			{ exact: $exactMatch, queryKey: getGetMyOrganizationQueryKey() },
			updater,
		);
	};
};

/**
 * @summary Get the authenticated user's own organization record
 */
export const useGetGetMyOrganizationQueryData = () => {
	const queryClient = useQueryClient();
	return () =>
		queryClient.getQueryData<Awaited<ReturnType<typeof getMyOrganization>>>(
			getGetMyOrganizationQueryKey(),
		);
};

export const getGetMyOrganizationSettingsUrl = () => {
	return `/organizations/me/settings`;
};

/**
 * @summary Get the authenticated user's application settings and preferences
 */
export const getMyOrganizationSettings = async (
	options?: Parameters<typeof customFetch>[1],
): Promise<GetMyOrganizationSettings200> => {
	return customFetch<GetMyOrganizationSettings200>(
		getGetMyOrganizationSettingsUrl(),
		{
			...options,
			method: "GET",
		},
	);
};

export const getGetMyOrganizationSettingsQueryKey = () => {
	return ["organizations", "me", "settings"] as const;
};

export const getGetMyOrganizationSettingsQueryOptions = <
	TData = Awaited<ReturnType<typeof getMyOrganizationSettings>>,
	TError = GetMyOrganizationSettings400 | GetMyOrganizationSettings500,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getMyOrganizationSettings>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customFetch>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetMyOrganizationSettingsQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getMyOrganizationSettings>>
	> = ({ signal }) => getMyOrganizationSettings({ signal, ...requestOptions });

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getMyOrganizationSettings>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyOrganizationSettingsQueryResult = NonNullable<
	Awaited<ReturnType<typeof getMyOrganizationSettings>>
>;
export type GetMyOrganizationSettingsQueryError =
	| GetMyOrganizationSettings400
	| GetMyOrganizationSettings500;

export function useGetMyOrganizationSettings<
	TData = Awaited<ReturnType<typeof getMyOrganizationSettings>>,
	TError = GetMyOrganizationSettings400 | GetMyOrganizationSettings500,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getMyOrganizationSettings>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getMyOrganizationSettings>>,
					TError,
					Awaited<ReturnType<typeof getMyOrganizationSettings>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyOrganizationSettings<
	TData = Awaited<ReturnType<typeof getMyOrganizationSettings>>,
	TError = GetMyOrganizationSettings400 | GetMyOrganizationSettings500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getMyOrganizationSettings>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getMyOrganizationSettings>>,
					TError,
					Awaited<ReturnType<typeof getMyOrganizationSettings>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyOrganizationSettings<
	TData = Awaited<ReturnType<typeof getMyOrganizationSettings>>,
	TError = GetMyOrganizationSettings400 | GetMyOrganizationSettings500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getMyOrganizationSettings>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get the authenticated user's application settings and preferences
 */

export function useGetMyOrganizationSettings<
	TData = Awaited<ReturnType<typeof getMyOrganizationSettings>>,
	TError = GetMyOrganizationSettings400 | GetMyOrganizationSettings500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getMyOrganizationSettings>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetMyOrganizationSettingsQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get the authenticated user's application settings and preferences
 */
export const useSetGetMyOrganizationSettingsQueryData = () => {
	const queryClient = useQueryClient();
	return (
		updater:
			| Awaited<ReturnType<typeof getMyOrganizationSettings>>
			| undefined
			| ((
					old:
						| Awaited<ReturnType<typeof getMyOrganizationSettings>>
						| undefined,
			  ) => Awaited<ReturnType<typeof getMyOrganizationSettings>> | undefined),
		$exactMatch: boolean = true,
	) => {
		queryClient.setQueriesData<
			Awaited<ReturnType<typeof getMyOrganizationSettings>>
		>(
			{ exact: $exactMatch, queryKey: getGetMyOrganizationSettingsQueryKey() },
			updater,
		);
	};
};

/**
 * @summary Get the authenticated user's application settings and preferences
 */
export const useGetGetMyOrganizationSettingsQueryData = () => {
	const queryClient = useQueryClient();
	return () =>
		queryClient.getQueryData<
			Awaited<ReturnType<typeof getMyOrganizationSettings>>
		>(getGetMyOrganizationSettingsQueryKey());
};

export const getUpdateMyOrganizationSettingsUrl = () => {
	return `/organizations/me/settings`;
};

/**
 * @summary Update the authenticated user's application settings and preferences
 */
export const updateMyOrganizationSettings = async (
	updateMyOrganizationSettingsBody: UpdateMyOrganizationSettingsBody,
	options?: Parameters<typeof customFetch>[1],
): Promise<UpdateMyOrganizationSettings200> => {
	const getHeaders = (
		h?: NonNullable<RequestInit["headers"]>,
	): Record<string, string | readonly string[]> => {
		if (!h) return {};
		if (h instanceof Headers) return Object.fromEntries(h.entries());
		if (Symbol.iterator in h) {
			return Object.fromEntries(
				Array.from(
					h as Iterable<Iterable<string>>,
					(entry) => Array.from(entry) as [string, string],
				),
			);
		}
		const headers: Record<string, string | readonly string[]> = {};
		for (const [name, value] of Object.entries<
			string | readonly string[] | undefined
		>(h)) {
			if (value !== undefined) headers[name] = value;
		}
		return headers;
	};
	return customFetch<UpdateMyOrganizationSettings200>(
		getUpdateMyOrganizationSettingsUrl(),
		{
			...options,
			method: "PATCH",
			headers: {
				"Content-Type": "application/json",
				...getHeaders(options?.headers),
			},
			body: JSON.stringify(updateMyOrganizationSettingsBody),
		},
	);
};

export const getUpdateMyOrganizationSettingsMutationKey = () =>
	["updateMyOrganizationSettings"] as const;

export const getUpdateMyOrganizationSettingsMutationOptions = <
	TError = UpdateMyOrganizationSettings400 | UpdateMyOrganizationSettings500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateMyOrganizationSettings>>,
		TError,
		UpdateMyOrganizationSettingsMutationVariables,
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateMyOrganizationSettings>>,
	TError,
	UpdateMyOrganizationSettingsMutationVariables,
	TContext
> => {
	const mutationKey = getUpdateMyOrganizationSettingsMutationKey();
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateMyOrganizationSettings>>,
		UpdateMyOrganizationSettingsMutationVariables
	> = (props) => {
		const { data } = props ?? {};

		return updateMyOrganizationSettings(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateMyOrganizationSettingsMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateMyOrganizationSettings>>
>;
export type UpdateMyOrganizationSettingsMutationBody =
	UpdateMyOrganizationSettingsBody;
export type UpdateMyOrganizationSettingsMutationError =
	| UpdateMyOrganizationSettings400
	| UpdateMyOrganizationSettings500;
export type UpdateMyOrganizationSettingsMutationVariables = {
	data: UpdateMyOrganizationSettingsBody;
};

/**
 * @summary Update the authenticated user's application settings and preferences
 */
export const useUpdateMyOrganizationSettings = <
	TError = UpdateMyOrganizationSettings400 | UpdateMyOrganizationSettings500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updateMyOrganizationSettings>>,
			TError,
			UpdateMyOrganizationSettingsMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof updateMyOrganizationSettings>>,
	TError,
	UpdateMyOrganizationSettingsMutationVariables,
	TContext
> => {
	return useMutation(
		getUpdateMyOrganizationSettingsMutationOptions(options),
		queryClient,
	);
};
export const getUpdateMyOrganizationPollTimesUrl = () => {
	return `/organizations/me/poll-times`;
};

/**
 * @summary Update the authenticated user's device polling intervals
 */
export const updateMyOrganizationPollTimes = async (
	updateMyOrganizationPollTimesBody: UpdateMyOrganizationPollTimesBody,
	options?: Parameters<typeof customFetch>[1],
): Promise<UpdateMyOrganizationPollTimes200> => {
	const getHeaders = (
		h?: NonNullable<RequestInit["headers"]>,
	): Record<string, string | readonly string[]> => {
		if (!h) return {};
		if (h instanceof Headers) return Object.fromEntries(h.entries());
		if (Symbol.iterator in h) {
			return Object.fromEntries(
				Array.from(
					h as Iterable<Iterable<string>>,
					(entry) => Array.from(entry) as [string, string],
				),
			);
		}
		const headers: Record<string, string | readonly string[]> = {};
		for (const [name, value] of Object.entries<
			string | readonly string[] | undefined
		>(h)) {
			if (value !== undefined) headers[name] = value;
		}
		return headers;
	};
	return customFetch<UpdateMyOrganizationPollTimes200>(
		getUpdateMyOrganizationPollTimesUrl(),
		{
			...options,
			method: "PATCH",
			headers: {
				"Content-Type": "application/json",
				...getHeaders(options?.headers),
			},
			body: JSON.stringify(updateMyOrganizationPollTimesBody),
		},
	);
};

export const getUpdateMyOrganizationPollTimesMutationKey = () =>
	["updateMyOrganizationPollTimes"] as const;

export const getUpdateMyOrganizationPollTimesMutationOptions = <
	TError = UpdateMyOrganizationPollTimes400 | UpdateMyOrganizationPollTimes500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateMyOrganizationPollTimes>>,
		TError,
		UpdateMyOrganizationPollTimesMutationVariables,
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateMyOrganizationPollTimes>>,
	TError,
	UpdateMyOrganizationPollTimesMutationVariables,
	TContext
> => {
	const mutationKey = getUpdateMyOrganizationPollTimesMutationKey();
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateMyOrganizationPollTimes>>,
		UpdateMyOrganizationPollTimesMutationVariables
	> = (props) => {
		const { data } = props ?? {};

		return updateMyOrganizationPollTimes(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateMyOrganizationPollTimesMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateMyOrganizationPollTimes>>
>;
export type UpdateMyOrganizationPollTimesMutationBody =
	UpdateMyOrganizationPollTimesBody;
export type UpdateMyOrganizationPollTimesMutationError =
	| UpdateMyOrganizationPollTimes400
	| UpdateMyOrganizationPollTimes500;
export type UpdateMyOrganizationPollTimesMutationVariables = {
	data: UpdateMyOrganizationPollTimesBody;
};

/**
 * @summary Update the authenticated user's device polling intervals
 */
export const useUpdateMyOrganizationPollTimes = <
	TError = UpdateMyOrganizationPollTimes400 | UpdateMyOrganizationPollTimes500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updateMyOrganizationPollTimes>>,
			TError,
			UpdateMyOrganizationPollTimesMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof updateMyOrganizationPollTimes>>,
	TError,
	UpdateMyOrganizationPollTimesMutationVariables,
	TContext
> => {
	return useMutation(
		getUpdateMyOrganizationPollTimesMutationOptions(options),
		queryClient,
	);
};
export const getGetOrganizationUrl = (orgId: string) => {
	return `/organizations/${orgId}`;
};

/**
 * @summary Get a single organization by OrgId (admin only)
 */
export const getOrganization = async (
	orgId: string,
	options?: Parameters<typeof customFetch>[1],
): Promise<Organization> => {
	return customFetch<Organization>(getGetOrganizationUrl(orgId), {
		...options,
		method: "GET",
	});
};

export const getGetOrganizationQueryKey = (orgId: string) => {
	return ["organizations", orgId] as const;
};

export const getGetOrganizationQueryOptions = <
	TData = Awaited<ReturnType<typeof getOrganization>>,
	TError =
		| GetOrganization400
		| GetOrganization403
		| GetOrganization404
		| GetOrganization500,
>(
	orgId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getOrganization>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetOrganizationQueryKey(orgId);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganization>>> = ({
		signal,
	}) => getOrganization(orgId, { signal, ...requestOptions });

	return {
		queryKey,
		queryFn,
		enabled: orgId !== null && orgId !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getOrganization>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationQueryResult = NonNullable<
	Awaited<ReturnType<typeof getOrganization>>
>;
export type GetOrganizationQueryError =
	| GetOrganization400
	| GetOrganization403
	| GetOrganization404
	| GetOrganization500;

export function useGetOrganization<
	TData = Awaited<ReturnType<typeof getOrganization>>,
	TError =
		| GetOrganization400
		| GetOrganization403
		| GetOrganization404
		| GetOrganization500,
>(
	orgId: string,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getOrganization>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getOrganization>>,
					TError,
					Awaited<ReturnType<typeof getOrganization>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganization<
	TData = Awaited<ReturnType<typeof getOrganization>>,
	TError =
		| GetOrganization400
		| GetOrganization403
		| GetOrganization404
		| GetOrganization500,
>(
	orgId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getOrganization>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getOrganization>>,
					TError,
					Awaited<ReturnType<typeof getOrganization>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganization<
	TData = Awaited<ReturnType<typeof getOrganization>>,
	TError =
		| GetOrganization400
		| GetOrganization403
		| GetOrganization404
		| GetOrganization500,
>(
	orgId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getOrganization>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a single organization by OrgId (admin only)
 */

export function useGetOrganization<
	TData = Awaited<ReturnType<typeof getOrganization>>,
	TError =
		| GetOrganization400
		| GetOrganization403
		| GetOrganization404
		| GetOrganization500,
>(
	orgId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getOrganization>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetOrganizationQueryOptions(orgId, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get a single organization by OrgId (admin only)
 */
export const useSetGetOrganizationQueryData = () => {
	const queryClient = useQueryClient();
	return (
		orgId: string,
		updater:
			| Awaited<ReturnType<typeof getOrganization>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof getOrganization>> | undefined,
			  ) => Awaited<ReturnType<typeof getOrganization>> | undefined),
		$exactMatch: boolean = true,
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof getOrganization>>>(
			{ exact: $exactMatch, queryKey: getGetOrganizationQueryKey(orgId) },
			updater,
		);
	};
};

/**
 * @summary Get a single organization by OrgId (admin only)
 */
export const useGetGetOrganizationQueryData = () => {
	const queryClient = useQueryClient();
	return (orgId: string) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof getOrganization>>>(
			getGetOrganizationQueryKey(orgId),
		);
};

export const getUpdateOrganizationUrl = (orgId: string) => {
	return `/organizations/${orgId}`;
};

/**
 * @summary Update an existing organization (admin only)
 */
export const updateOrganization = async (
	orgId: string,
	organizationUpdate: OrganizationUpdate,
	options?: Parameters<typeof customFetch>[1],
): Promise<Organization> => {
	const getHeaders = (
		h?: NonNullable<RequestInit["headers"]>,
	): Record<string, string | readonly string[]> => {
		if (!h) return {};
		if (h instanceof Headers) return Object.fromEntries(h.entries());
		if (Symbol.iterator in h) {
			return Object.fromEntries(
				Array.from(
					h as Iterable<Iterable<string>>,
					(entry) => Array.from(entry) as [string, string],
				),
			);
		}
		const headers: Record<string, string | readonly string[]> = {};
		for (const [name, value] of Object.entries<
			string | readonly string[] | undefined
		>(h)) {
			if (value !== undefined) headers[name] = value;
		}
		return headers;
	};
	return customFetch<Organization>(getUpdateOrganizationUrl(orgId), {
		...options,
		method: "PATCH",
		headers: {
			"Content-Type": "application/json",
			...getHeaders(options?.headers),
		},
		body: JSON.stringify(organizationUpdate),
	});
};

export const getUpdateOrganizationMutationKey = () =>
	["updateOrganization"] as const;

export const getUpdateOrganizationMutationOptions = <
	TError =
		| UpdateOrganization400
		| UpdateOrganization403
		| UpdateOrganization404
		| UpdateOrganization500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateOrganization>>,
		TError,
		UpdateOrganizationMutationVariables,
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateOrganization>>,
	TError,
	UpdateOrganizationMutationVariables,
	TContext
> => {
	const mutationKey = getUpdateOrganizationMutationKey();
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateOrganization>>,
		UpdateOrganizationMutationVariables
	> = (props) => {
		const { orgId, data } = props ?? {};

		return updateOrganization(orgId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateOrganizationMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateOrganization>>
>;
export type UpdateOrganizationMutationBody = OrganizationUpdate;
export type UpdateOrganizationMutationError =
	| UpdateOrganization400
	| UpdateOrganization403
	| UpdateOrganization404
	| UpdateOrganization500;
export type UpdateOrganizationMutationVariables = {
	orgId: string;
	data: OrganizationUpdate;
};

/**
 * @summary Update an existing organization (admin only)
 */
export const useUpdateOrganization = <
	TError =
		| UpdateOrganization400
		| UpdateOrganization403
		| UpdateOrganization404
		| UpdateOrganization500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updateOrganization>>,
			TError,
			UpdateOrganizationMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof updateOrganization>>,
	TError,
	UpdateOrganizationMutationVariables,
	TContext
> => {
	return useMutation(
		getUpdateOrganizationMutationOptions(options),
		queryClient,
	);
};
export const getDeleteOrganizationUrl = (orgId: string) => {
	return `/organizations/${orgId}`;
};

/**
 * @summary Soft-delete an organization by ID (admin only)
 */
export const deleteOrganization = async (
	orgId: string,
	options?: Parameters<typeof customFetch>[1],
): Promise<Organization> => {
	return customFetch<Organization>(getDeleteOrganizationUrl(orgId), {
		...options,
		method: "DELETE",
	});
};

export const getDeleteOrganizationMutationKey = () =>
	["deleteOrganization"] as const;

export const getDeleteOrganizationMutationOptions = <
	TError =
		| DeleteOrganization400
		| DeleteOrganization403
		| DeleteOrganization404
		| DeleteOrganization500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deleteOrganization>>,
		TError,
		DeleteOrganizationMutationVariables,
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof deleteOrganization>>,
	TError,
	DeleteOrganizationMutationVariables,
	TContext
> => {
	const mutationKey = getDeleteOrganizationMutationKey();
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof deleteOrganization>>,
		DeleteOrganizationMutationVariables
	> = (props) => {
		const { orgId } = props ?? {};

		return deleteOrganization(orgId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type DeleteOrganizationMutationResult = NonNullable<
	Awaited<ReturnType<typeof deleteOrganization>>
>;

export type DeleteOrganizationMutationError =
	| DeleteOrganization400
	| DeleteOrganization403
	| DeleteOrganization404
	| DeleteOrganization500;
export type DeleteOrganizationMutationVariables = { orgId: string };

/**
 * @summary Soft-delete an organization by ID (admin only)
 */
export const useDeleteOrganization = <
	TError =
		| DeleteOrganization400
		| DeleteOrganization403
		| DeleteOrganization404
		| DeleteOrganization500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof deleteOrganization>>,
			TError,
			DeleteOrganizationMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof deleteOrganization>>,
	TError,
	DeleteOrganizationMutationVariables,
	TContext
> => {
	return useMutation(
		getDeleteOrganizationMutationOptions(options),
		queryClient,
	);
};
